import api from '@/apis/sa/sASaleInvoiceReferenceAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sASaleInvoiceReference', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_sale_invoice_reference',
    field: {
      key: 'ref_id',
    },
  },
  makeSalesVouchers: false, //đã lập chứng từ bán hàng chưa
  saleVoucherNo: null, //Số chứng từ bán hàng
  systemDate: new Date(), //Ngày hệ thống
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * kiểm tra đã lập chứng từ bán hàng chưa
   * TTLONG 15/09/2022
   * @param {*} context
   * @param {*} param
   */
  async checkMakeSalesVouchers(context, param) {
    var res = await api.checkMakeSalesVouchers(param);
    if (res) {
      context.commit('setMakeSalesVouchers', res);
    }
  },
  /**
   * lấy ngày hệ thống
   * TTLONG 20/09/2022
   * @param {*} context
   */
  async getSystemDate(context) {
    return new Promise(async (resolve, reject) => {
      var res = await api.getSystemDate();
      if (res) {
        resolve(res);
      } else {
        reject(false);
      }
    });
  },
  /**
   * Lấy số chứng từ bán hàng theo số hóa đơn hủy
   * TTLONG 15/09/2022
   * @param {*} context
   * @param {*} param
   */
  async getSaleVoucherNo(context, param) {
    var res = await api.getSaleVoucherNo(param);
    if (res) {
      context.commit('setSaleVoucherNo', res);
    }
    return res;
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * Thiết lập giá trị cho makeSalesVouchers
   * @param {*} state
   * @param {*} data
   */
  setMakeSalesVouchers(state, data) {
    state.makeSalesVouchers = data;
  },
  /**
   * Thiết lập giá trị cho systemDate
   * @param {*} state
   * @param {*} data
   */
  setSystemDate(state, data) {
    state.systemDate = data;
  },
  /**
   * Thiết lập giá trị số chứng từ bán hàng
   * @param {*} state
   * @param {*} data
   */
  getSaleVoucherNo(state, data) {
    state.saleVoucherNo = data;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
